import { values } from 'lodash';

export default (err: string) => values(err).join('. ');